import { NgControl, ValidationErrors } from '@angular/forms';
import validatorsFormatters from './default-validators-formatters';
import { FormErrorsFormatter } from './error-formatter';
import { ValidatorErrorFormat } from './default-form-errors-formatter.types';

export class DefaultFormErrorsFormatter implements FormErrorsFormatter {
  public static validatorsFormatters = validatorsFormatters;

  public readonly displayMaxErrors: number = 1;
  public readonly validatorsFormatters: ValidatorErrorFormat = validatorsFormatters;
  public readonly fieldsFormatters: Record<string, ValidatorErrorFormat> = {};

  public format(control: NgControl): string {
    const errors: ValidationErrors | null = control.errors;

    if (!errors) return '';

    const fieldFormatter = control.name && this.fieldsFormatters?.[control.name];
    const defaultFormatter = this.validatorsFormatters;

    const formattedErrors: string[] = Object.keys(errors).reduce((acc, errorKey) => {
      const formatter =
        (fieldFormatter && fieldFormatter[errorKey]) || (defaultFormatter && defaultFormatter[errorKey]);

      if (formatter) {
        acc.push(formatter(errors[errorKey], control.name));
      }

      return acc;
    }, [] as string[]);

    return formattedErrors.slice(0, this.displayMaxErrors).join(', ');
  }
}
